import { useAuth } from '../../../auth/auth-context'
import useFetch from '../../../_fetch'
import { getColumns } from './columns'
import { Table } from '../_table/table'

export default function CampaignReport() {
    const {user} = useAuth()
    const { doFetch } = useFetch()
    const isPublisher = user?.kind === 'publisher'
    const columns = getColumns(isPublisher)
    
  return (
    <Table 
        columns={columns} 
        getData={async (fromDate, toDate) => {
            const res = await doFetch('/data/total-transactions-by-campaign', {
                fromDate, toDate, timezoneOffsetMinutes: new Date().getTimezoneOffset()
            })
            if (!res.ok) throw new Error('Campaign performance could not be fetched for the selected period.')

            const data = await res.json()
            if (!Array.isArray(data)) throw new Error('The server returned an unexpected campaign report format.')

            for(const d of data) {
                d.conversionRate = d.totalClicks ? d.totalTransactions / d.totalClicks * 100 : 0
                d.roas = d.totalCommission ? d.totalOrderAmount / d.totalCommission : 0
                d.cpc = d.totalClicks ? d.totalCommission / d.totalClicks : 0
                d.epc = d.totalClicks
                    ? (isPublisher ? d.totalCommission : d.totalOrderAmount) / d.totalClicks
                    : 0
            }

            return data
        }}
        title='Campaign Report'
        description='Compare campaign traffic, conversions, earnings, and efficiency across your portfolio.'
        entityLabel='campaigns'
        pageKey='campaign-report'
        defaultSort={isPublisher ? 'totalCommission' : 'totalOrderAmount'}
    />)
}
